import { render, staticRenderFns } from "./RuischoolscUserDuShu.vue?vue&type=template&id=764100c2&scoped=true&"
import script from "./RuischoolscUserDuShu.vue?vue&type=script&lang=js&"
export * from "./RuischoolscUserDuShu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764100c2",
  null
  
)

export default component.exports